import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Flag } from 'lucide-react';

import { MilestoneCatalogue } from './MilestoneCatalogue';

/**
 * MST-1.1. The milestone catalogue.
 *
 * ⚠️ A MILESTONE IS A NAMED ROW, NOT A FLAG ON A STAGE, and this screen is why.
 * "Install Complete" is reached through the Residential pipeline and both
 * Commercial ones. If it were a bare per-stage boolean those would be three
 * unrelated things sharing a name, a commission rule would have to be written
 * once per pipeline, and no report could group them. Defined once here, pointed
 * at from each stage.
 *
 * ⚠️ IT LIVES UNDER PIPELINES RATHER THAN ITS OWN NAV ENTRY, deliberately: a
 * milestone is meaningless until a stage points at it, and the stage editor is
 * two clicks away on this same tab. A separate top-level page would put the
 * definition and its only use in different parts of the app.
 *
 * ⚠️ MST-1.90. THIS IS NO LONGER THE ONLY WAY IN. The Commission tab reports the
 * absence of milestones in two places and could not act on either, so
 * `MilestoneSetupPanel` shows the same catalogue over that page. The body lives
 * in `MilestoneCatalogue` so the two hosts cannot drift apart; this file is the
 * Card frame and nothing else.
 */
export function MilestonesTab() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Flag className="h-5 w-5" />
          Milestones
        </CardTitle>
        <CardDescription>
          Points in a job worth recording the date of, such as funding or install completion.
          Map a stage to a milestone in that pipeline&apos;s stage settings. Several pipelines can
          share one milestone, so it is reported as a single thing.
        </CardDescription>
      </CardHeader>

      <CardContent>
        <MilestoneCatalogue />
      </CardContent>
    </Card>
  );
}

export default MilestonesTab;
